import { memo, useCallback, useEffect, useState } from "react";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoHorizontalTabs } from "@redotech/redo-web/arbiter-components/tabs/redo-horizontal-tabs";
import { Text } from "@redotech/redo-web/text";
import * as css from "./dev-tools-overlay.module.css";
import { MocksTab } from "./mocks-tab";

type DevToolsTab = "mocks";

const TABS: { key: DevToolsTab; label: string }[] = [
  { key: "mocks", label: "Mocks" },
];

export const DevToolsOverlay = memo(function DevToolsOverlay() {
  const [open, setOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState<DevToolsTab>("mocks");

  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.ctrlKey && e.shiftKey && e.key === "D") {
      e.preventDefault();
      setOpen((prev) => !prev);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  if (!open) {
    return null;
  }

  return (
    <div className={css.panel}>
      <div className={css.header}>
        <Text fontSize="sm" fontWeight="semibold">
          Redo Developer Tools
        </Text>
        <RedoButton
          hierarchy="tertiary"
          onClick={() => setOpen(false)}
          size="sm"
          text="✕"
        />
      </div>
      <div className={css.tabsWrapper}>
        <RedoHorizontalTabs
          drawBottomLine
          pl="xl"
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          tabs={TABS}
        />
      </div>
      <div className={css.content}>
        {selectedTab === "mocks" && <MocksTab />}
      </div>
      <div className={css.footer}>
        <RedoButton
          hierarchy="primary"
          onClick={() => window.location.reload()}
          size="sm"
          style={{ width: "100%" }}
          text="Refresh Page"
        />
      </div>
    </div>
  );
});
